module.exports = __webpack_public_path__ + "img/zxcover_sample.29b7bec5.png";